<template>
  <div class="default-table permissions-table">
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          @click.prevent="$emit('new', true)"
          app
          fab
          bottom
          right
          fixed
          :color="get_interface.colors.neworder"
          class="new-btn-float"
          style="top: 5px;"
        >
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.permissions.new.title }}</span>
    </v-tooltip>
    <DataTable
      name="permissions"
      :items="data"
      :tablehdrs="tableheaders.permissions"
      itemkey="id"
      sortby="id"
      :sortdesc="false"
    >
      <template v-slot:default="{ item }">
        <tr
          :key="item.id"
          @dblclick="$emit('edit', item)"
          class="table-row permission-row"
        >
          <td>
            <strong>{{ item.id }}</strong>
          </td>
          <td>
            <v-chip :color="item.color" dark>{{ item.name }}</v-chip>
          </td>
          <td class="actions-col">
            <Actions :value="item" @edit="e => $emit('edit', e)" />
          </td>
        </tr>
      </template>
      <template v-slot:mobile="{ item }">
        <tr
          :key="`mb-${item.id}`"
          @dblclick="$emit('edit', item)"
          class="mobile_row table-row permission-row"
        >
          <td class="mobile_col">
            <ul class="flex-content pl-2">
              <li class="flex-item" :data-label="`${lang.permissions.datatable.headers.id}:`">
                {{ item.id }}
              </li>
              <li class="flex-item" :data-label="`${lang.permissions.datatable.headers.title}:`">
                <v-chip :color="item.color" dark>{{ item.name }}</v-chip>
              </li>
              <li class="flex-item actions-row" :data-label="lang.permissions.datatable.headers.action">
                <Actions :value="item" @edit="e => $emit('edit', e)" />
              </li>
            </ul>
          </td>
        </tr>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/templates/global/DataTable'
import Actions from './Actions'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { DataTable, Actions },
  mixins: [ appdata, utils ],
  computed: {
    data: function () {
      return this.get_data.users_permissions || []
    }
  }
}
</script>

<style src="../styles/list.scss" lang="scss"></style>
